"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderOverviewAICommand = void 0;
class RenderOverviewAICommand extends CustomEvent {
    constructor(element, overviewAI, studyId) {
        const detail = { element, overviewAI, studyId };
        super('', { detail });
    }
}
exports.RenderOverviewAICommand = RenderOverviewAICommand;
